import Box from "@mui/material/Box";
import * as React from "react";

import { MetadataForm, MetadataView } from "@/shared/components";
import { AutocompleteType } from "@/shared/components/TagAndMetadataAutocomplete";
import { UpdateActionRequest } from "@/shared/domain/actions/ActionRecord";

interface UpdateActionMetadataProps {
  initialMetadata: Record<string, string>;
  onChange: (updates: UpdateActionRequest) => void;
  setErrorText: (arg: string) => void;
  canEdit?: boolean;
}

export function UpdateActionMetadata({
  initialMetadata,
  onChange,
  setErrorText,
  canEdit,
}: UpdateActionMetadataProps) {
  const [metadata, setMetadata] =
    React.useState<Record<string, unknown>>(initialMetadata);

  const metadataAdded = (key: string, value: string) => {
    if (key && value) {
      const metadataClone = {
        ...metadata,
        [key]: value,
      };
      setMetadata(metadataClone);
      updateMetadata({
        metadata_changeset: {
          put_fields: { [key]: value },
        },
      });
    }
  };

  const updateMetadata = (updates: UpdateActionRequest) => {
    setErrorText("");
    onChange(updates);
  };

  return (
    <Box>
      <MetadataView
        metadata={metadata}
        disabled={!canEdit}
        onChange={(metadata: Record<string, unknown>, keyDeleted?: string) => {
          setMetadata(metadata);
          if (keyDeleted) {
            void updateMetadata({
              metadata_changeset: {
                remove_fields: [keyDeleted],
              },
            });
          }
        }}
      />
      <MetadataForm
        metadata={metadata}
        autocompleteType={AutocompleteType.ActionMetadataKeys}
        onAddMetadata={metadataAdded}
        disabled={!canEdit}
      />
    </Box>
  );
}
